import React from 'react';
import './Newsletters.css';
import { useState, useEffect } from 'react';
import client from '../../sanityClient';

export default function NewslettersList(props) {

    // Array of PDFs with name and URL
    // const pdfFiles = [
    //     { name: "Outreach Brochure 2024", url: "/pdfs/OUTREACH BROCHURE 24.pdf" },
    //     { name: "Academic Outreach Newsletter January 2024", url: "/pdfs/Academic Outreach Newsletter Jan 24.pdf" },
    //     { name: "Academic Outreach Newsletter August 2024", url: "/pdfs/Academic Outreach Newsletter Aug 24.pdf" },
    // ];


    const [newsletters, setNewsletters] = useState([]);

    useEffect(() => {
        client.fetch(`*[_type == "newsletter"]{
      title,
      "url": pdfFile.asset->url
    }`).then((data) => setNewsletters(data));
    }, []);

    return (
        <section className="newsletter-section">
            <h1>Newsletters</h1>
            <ul>
                {newsletters.map((pdf, index) => (
                    <li key={index}>
                        <a href={pdf.url} download>{pdf.title}</a>
                    </li>
                ))}
            </ul>
        </section>
    );
}
